import { Controller, useFormContext } from 'react-hook-form';

import { UserSex } from '@data';
import { useTranslate } from '@i18n';
import { Heading4, Select, Stack, Text, u } from '@ui';

import { UserSettingsForm } from '../../UserSettings';

import * as css from './SexSection.css';

export const SexSection = () => {
    const t = useTranslate();
    const { control } = useFormContext<UserSettingsForm>();
    const options = [
        {
            value: 'NONE',
            label: t('user_welcome_wizard.sex_options_prefer_not_to_say_title'),
        },
        {
            value: 'M' as UserSex,
            label: t('user_welcome_wizard.sex_options_male_title'),
        },
        {
            value: 'F' as UserSex,
            label: t('user_welcome_wizard.sex_options_female_title'),
        },
        {
            value: 'O' as UserSex,
            label: t('user_welcome_wizard.sex_options_other_title'),
        },
    ];

    return (
        <div className={css.section}>
            <Heading4>{t('user_settings.sex_section')}</Heading4>
            <Text variant="pSmall" color="muted">
                {t('user_settings.sex_optional')}
            </Text>
            <div className={css.fieldGrid}>
                <Controller
                    control={control}
                    name="sex"
                    render={({ field }) => (
                        <Stack gap={u(1)}>
                            <Select
                                options={options}
                                selectedValue={field.value ?? undefined}
                                onChange={(values) =>
                                    field.onChange(
                                        values[0] === 'NONE' ? null : (values[0] as UserSex | undefined) ?? null,
                                    )
                                }
                                label={t('user_settings.sex_label')}
                                placeholder={t('user_settings.sex_label')}
                                width="100%"
                            />
                        </Stack>
                    )}
                />
            </div>
        </div>
    );
};
